import PropTypes from 'prop-types';
import { List } from 'framework7-react';
import React, { useEffect } from 'react';

import { I18n } from 'Locales';
import { mockFunction } from 'Helpers';
import { SearchAndSelect, TextField } from 'Components';

const handleSelect = ({ callback, items, key, marketingCompanyId, updateTransientProps }, e) => {
  const selectedIndex = e.target.value;
  const selectedOption = items[selectedIndex];

  updateTransientProps({
    [key]: selectedOption.id,
    [`${key}_name`]: selectedOption.name,
    [`${key}_type`]: selectedOption.client_type
  });
  callback && callback({ marketingCompanyId, clientId: selectedOption.id });
};

const handleSelectSigner = (updateTransientProps, key, e) => {
  updateTransientProps({ [key]: e.target.value });
};

const renderOptions = ({ options, type }) => {
  const selectableOptions = options.map((option, index) => (
    <option key={option.id || index} value={index}>
      {option.name}
    </option>
  ));
  selectableOptions.unshift(
    <option key="default" value="" disabled selected={true}>
      {I18n.t(`admin:reOnboardModal.${type}`)}
    </option>
  );

  return selectableOptions;
};

const renderSigners = ({ signers }) => {
  const selectableOptions = signers.map((signer = {}, index) => (
    <option key={index} value={signer?.signer?.id} select={index[0]}>
      {signer?.signer?.full_name}
    </option>
  ));

  return selectableOptions;
};

const Reonboard = ({ transient = {}, getCampaignsByClient = mockFunction, updateTransientProps = mockFunction }) => {
  const {
    campaigns = [],
    clients = [],
    full_name = '',
    selected_campaign_name = '',
    selected_client = '',
    selected_client_name = '',
    signers = [],
    userOnboardingProfile = {}
  } = transient;
  const marketingCompanyId = userOnboardingProfile?.marketing_company?.id;

  useEffect(() => {
    updateTransientProps({ selected_signer: signers[0]?.signer?.id });
  }, [signers]);

  return (
    <>
      <List noHairlines className="w-full">
        <TextField
          label={I18n.t('admin:reOnboardModal.client')}
          onChange={handleSelect.bind(null, {
            callback: getCampaignsByClient,
            items: clients,
            key: 'selected_client',
            marketingCompanyId,
            updateTransientProps
          })}
          type="select">
          {renderOptions({ options: clients, type: 'clientPlaceholder' })}
        </TextField>

        {selected_client && (
          <SearchAndSelect
            displayProperty="name"
            fieldName="selectedCampaigns"
            label={I18n.t('admin:reOnboardModal.campaign')}
            multiple={true}
            options={campaigns}
            resetKey={selected_client}
            selectedProperty="id"
            updateTransientProps={updateTransientProps}
          />
        )}

        <TextField
          label={I18n.t('admin:reOnboardModal.signers')}
          onChange={handleSelectSigner.bind(null, updateTransientProps, 'selected_signer')}
          type="select">
          {renderSigners({ signers })}
        </TextField>
      </List>

      {selected_campaign_name !== '' && selected_client_name !== '' && (
        <div className="names-container">
          <span className="text-sm font-bold mr-4">{full_name}</span>
          <span>
            {I18n.t('admin:reOnboardModal.reonboardClientAndCampaign', {
              campaignName: selected_campaign_name,
              clientName: selected_client_name
            })}
          </span>
        </div>
      )}
    </>
  );
};

Reonboard.propTypes = {
  getCampaignsByClient: PropTypes.func,
  transient: PropTypes.object,
  updateTransientProps: PropTypes.func
};

export default Reonboard;
